import {LENS_PREPAID_PURCHASE_MIN_CENTS} from 'app/utils/constants';

/** Dollars as typed, to cents. Null for anything but a plain amount with at most two decimals. */
export function parseDollarsToCents(text: string): number | null {
  const trimmed = text.trim().replace(/,/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    return null;
  }
  return Math.round(Number(trimmed) * 100);
}

export const isPurchasableCents = (cents: number | null): cents is number =>
  cents !== null && cents >= LENS_PREPAID_PURCHASE_MIN_CENTS;
